import { Button } from "@/components/ui/button";

interface Props {
  isBuilding: boolean;
  progress: string;
  error: string | null;
  onDismiss: () => void;
}

export function IndexProgress({
  isBuilding,
  progress,
  error,
  onDismiss,
}: Props) {
  if (!isBuilding && !progress && !error) return null;

  return (
    <div className="rounded-md border p-4 space-y-2" role="status" aria-live="polite">
      {isBuilding && (
        <>
          <div className="flex items-center gap-2">
            <div className="size-4 animate-spin rounded-full border-2 border-primary border-t-transparent" />
            <span className="text-sm text-muted-foreground">{progress}</span>
          </div>
          <div className="h-2 w-full rounded-full bg-secondary">
            <div className="h-2 rounded-full bg-primary animate-pulse w-2/3" />
          </div>
        </>
      )}

      {!isBuilding && progress && !error && (
        <div className="flex items-center justify-between">
          <p className="text-sm text-green-600 dark:text-green-400">
            {progress}
          </p>
          <Button variant="ghost" size="xs" onClick={onDismiss}>
            Dismiss
          </Button>
        </div>
      )}

      {error && (
        <div className="flex items-center justify-between">
          <p className="text-sm text-destructive">{error}</p>
          <Button variant="ghost" size="xs" onClick={onDismiss}>
            Dismiss
          </Button>
        </div>
      )}
    </div>
  );
}
